import React from 'react';
import Loader from '../loader';
import {IExerciseDialogue} from '../../redux/exercise/interfaces';
import {ExerciseCard} from '../exercise-card/ExerciseCard';

import './styles.scss';

type Props = {
  cards: IExerciseDialogue[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (dialogue: IExerciseDialogue) => void;
  checkedCards?: number[];
  disabledButtons?: boolean;
}

export const ExerciseCardSection = ({
  showLoader = false,
  cards,
  onClickCard
}: Props): JSX.Element => {
  function handleClickCard(dialogue: IExerciseDialogue) {
    return () => {
      onClickCard(dialogue);
    };
  }

  return <section className="exercise-card-section">
    {showLoader ? <Loader/> : <ul className="exercise-card-section__list">
      {
        cards && cards.length && cards.map((card, i) => {
          return <li key={card.dialogId} className="exercise-card-section__item">
            <ExerciseCard
              card={card}
              onClick={handleClickCard(card)}/>
          </li>;
        })
      }
    </ul>}
  </section>;
};
